import { SelectedInlineInstrument, SelectedInlineInstrumentDate } from "helpers/types/instruments/selected"
import { IsoDate } from "helpers/types/dates"
import { OkReduxDataResult } from "model/state"
import { CompositionTypeData, getCompositionType } from "./composition"
import { PositionSetMetadata } from "./types"

function comparePositionSetDates(positionSetDate1: SelectedInlineInstrumentDate, positionSetDate2: SelectedInlineInstrumentDate) {
  if (positionSetDate1.date < positionSetDate2.date) {
    return -1
  }
  if (positionSetDate1.date > positionSetDate2.date) {
    return 1
  }
  return 0
}

export interface InlineMetadata extends PositionSetMetadata {
  type: undefined
  unavailable: false
}

const INLINE_PS_QUERY = `query ($modelId: String!, $currentDate: Date!, $positionSetDates: [PositionSetDateInput!], $segment: Segment) {
  model (id: $modelId) {
    simulation (positionSet: {dates: $positionSetDates, segment: $segment}, from: $currentDate, to: $currentDate) {
      composition {
        compositionBy (groupBy: LONG_SHORT) {
          id
        }
      }
    }
  }
}`

function inlineSelect(data: OkReduxDataResult<CompositionTypeData>, positionSet: SelectedInlineInstrument, metadataDate: IsoDate): InlineMetadata {
  return {
    type: undefined,
    name: positionSet.name || "Inline Position Set", // [TODO] Find a way to name those position sets
    earliestDate: positionSet.dates.toSorted(comparePositionSetDates)?.[0].date,
    latestDate: metadataDate,
    compositionType: getCompositionType(data),
    unavailable: false,
  }
}

export function getInlineQueryDefinition(positionSet: SelectedInlineInstrument, modelId: string, metadataDate: IsoDate) {
  const variables = { modelId, currentDate: metadataDate, segment: positionSet.segment, positionSetDates: positionSet.dates }
  return {
    query: INLINE_PS_QUERY,
    variables,
    queryKey: ["position-set", "metadata", "inline", variables],
    select: (data: OkReduxDataResult<CompositionTypeData>) => inlineSelect(data, positionSet, metadataDate),
  }
}
